var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17 10c3.866 0 7 2.462 7 5.5q0 .254-.029.5h-1.008q.037-.245.037-.5c0-2.485-2.686-4.5-6-4.5s-6 2.015-6 4.5q0 .255.037.5h-1.008a4 4 0 0 1-.029-.5c0-3.038 3.134-5.5 7-5.5M7 7c2.207 0 4.175.802 5.458 2.056l-.6.802C10.768 8.732 8.998 8 7 8c-3.314 0-6 2.015-6 4.5q0 .255.037.5H.029A4 4 0 0 1 0 12.5C0 9.462 3.134 7 7 7m10-4a3 3 0 1 1 0 6 3 3 0 0 1 0-6m0 1a2 2 0 1 0-.001 3.999A2 2 0 0 0 17 4M7 0a3 3 0 1 1 0 6 3 3 0 0 1 0-6m0 1a2 2 0 1 0-.001 3.999A2 2 0 0 0 7 1"
  })));
});
const SvgNavContactsIcon = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNavContactsIcon);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDI0IDE2Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgZmlsbD0iY3VycmVudENvbG9yIj4KICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICA8Zz4KICAgICAgICAgICAgICAgICAgICA8Zz4KICAgICAgICAgICAgICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8Zz4KICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMTcgMTBjMy44NjYgMCA3IDIuNDYyIDcgNS41IDAgLjE2OS0uMDEuMzM2LS4wMjkuNWgtMS4wMDhjLjAyNS0uMTY0LjAzNy0uMzMuMDM3LS41IDAtMi40ODUtMi42ODYtNC41LTYtNC41cy02IDIuMDE1LTYgNC41YzAgLjE3LjAxMi4zMzYuMDM3LjVoLTEuMDA4Yy0uMDItLjE2NC0uMDI5LS4zMzEtLjAyOS0uNSAwLTMuMDM4IDMuMTM0LTUuNSA3LTUuNXpNNyA3YzIuMjA3IDAgNC4xNzUuODAyIDUuNDU4IDIuMDU2bC0uNi44MDJDMTAuNzY4IDguNzMyIDguOTk4IDggNyA4Yy0zLjMxNCAwLTYgMi4wMTUtNiA0LjUgMCAuMTcuMDEyLjMzNi4wMzcuNUguMDI5Qy4wMDkgMTIuODM3IDAgMTIuNjcgMCAxMi41IDAgOS40NjIgMy4xMzQgNyA3IDd6bTEwLTRjMS42NTcgMCAzIDEuMzQzIDMgM3MtMS4zNDMgMy0zIDMtMy0xLjM0My0zLTMgMS4zNDMtMyAzLTN6bTAgMWMtMS4xMDUgMC0yIC44OTUtMiAycy44OTUgMiAyIDIgMi0uODk1IDItMi0uODk1LTItMi0yek03IDBjMS42NTcgMCAzIDEuMzQzIDMgM1M4LjY1NyA2IDcgNiA0IDQuNjU3IDQgM3MxLjM0My0zIDMtM3ptMCAxYy0xLjEwNSAwLTIgLjg5NS0yIDJzLjg5NSAyIDIgMiAyLS44OTUgMi0yLS44OTUtMi0yLTJ6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTYgLTU2NSkgdHJhbnNsYXRlKDUgMTk4KSB0cmFuc2xhdGUoMCAxMTYpIHRyYW5zbGF0ZSgwIDI0MCkgdHJhbnNsYXRlKDEwIDcpIHRyYW5zbGF0ZSgxIDQpIi8+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";